






























import { defineComponent, ref } from '@nuxtjs/composition-api'
import { ciEyeSlash } from '~/icons/source/solid/eye-slash'
import { ciEye } from '~/icons/source/solid/eye'
import { vue3Model } from '~/utils/nuxt3-migration'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    },
    required: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: 'current-password'
    },
    name: {
      type: String,
      required: false
    }
  },
  setup() {
    const passwordRevealed = ref(false)
    const passwordInputRef = ref<HTMLElement | null>(null)

    const revealPassword = () => {
      passwordRevealed.value = !passwordRevealed.value
      passwordInputRef.value && passwordInputRef.value.focus(true)
    }

    return {
      passwordRevealed,
      revealPassword,
      passwordInputRef,
      ciEyeSlash,
      ciEye
    }
  }
})
